import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import {
    fetchAccountManagers,
    fetchEventAccountManagers,
    fetchPjmLocationZipCodes,
    fetchPjmRegistrationSeasons,
    fetchSiteMarkets,
    fetchVendorBillItemPrograms,
    fetchVendorBillItemUtilities,
    fetchVendorBillTransactionIds,
    fetchSiteOptions,
    fetchMeterEnrollmentEnrollmentIdOptions,
} from './index';
import { IFilterOptionValue, IFetchFiltersOptionsByCompanyRequestParams, IFilterOption, ISiteMarket } from './interface';

export const useSiteOptionsListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.SITES, params],
        queryFn: ({ signal }) => fetchSiteOptions(params, signal),
        ...options,
    });
};

export const useMeterEnrollmentEnrollmentIdsListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.METER_ENROLLMENT_ENROLLMENT_IDS, params],
        queryFn: ({ signal }) => fetchMeterEnrollmentEnrollmentIdOptions(params, signal),
        ...options,
    });
};

export const useEventAccountManagersListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOptionValue[], Error>({
        queryKey: [QueryKey.EVENT_ACCOUNT_MANAGERS, params],
        queryFn: ({ signal }) => fetchEventAccountManagers(params, signal),
        ...options,
    });
};

export const useAccountManagersListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOptionValue[], Error>({
        queryKey: [QueryKey.ACCOUNT_MANAGERS, params],
        queryFn: ({ signal }) => fetchAccountManagers(params, signal),
        ...options,
    });
};

export const useMarketsListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<ISiteMarket[], Error>({
        queryKey: [QueryKey.SITE_MARKETS, params],
        queryFn: ({ signal }) => fetchSiteMarkets(params, signal),
        ...options,
    });
};

export const useVendorBillItemProgramsListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.VENDOR_BILL_ITEM_PROGRAMS, params],
        queryFn: ({ signal }) => fetchVendorBillItemPrograms(params, signal),
        ...options,
    });
};

export const useVendorBillItemUtilitiesListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.VENDOR_BILL_ITEMS_UTILITIES, params],
        queryFn: ({ signal }) => fetchVendorBillItemUtilities(params, signal),
        ...options,
    });
};

export const useVendorBillTransactionIdsListQuery = (params: IFetchFiltersOptionsByCompanyRequestParams, options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.VENDOR_BILL_TRANSACTION_IDS, params],
        queryFn: ({ signal }) => fetchVendorBillTransactionIds(params, signal),
        ...options,
    });
};

export const usePjmLocationZipCodesListQuery = (options = {}) => {
    return useQuery<IFilterOptionValue[], Error>({
        queryKey: [QueryKey.PJM_LOCATION_ZIP_CODES],
        queryFn: ({ signal }) => fetchPjmLocationZipCodes(signal),
        ...options,
    });
};

export const usePjmRegistrationSeasonsListQuery = (options = {}) => {
    return useQuery<IFilterOption[], Error>({
        queryKey: [QueryKey.PJM_REGISTRATION_SEASONS],
        queryFn: ({ signal }) => fetchPjmRegistrationSeasons(signal),
        ...options,
    });
};
